import { useMemo } from 'react';

import { debounce } from 'helpers';
import { observer } from 'mobx-react-lite';

import { SelectAsync } from '@components/select';
import { abbreviateDate } from '@utils/date';

import { api } from 'api';
import { useStore } from 'models/Provider';

export const JobSearch = observer(({ onSelect, company, job, currentJob, label }) => {
  const { t, lang } = useStore();

  const searchJobs = useMemo(
    () =>
      debounce((searchStr, callback) => {
        let jobs = [];
        api.jobs
          .search({
            companyId: company.id,
            title: searchStr || '',
            includeArchived: false,
            limit: 10,
          })
          .then((data) => {
            if (data.results.length) {
              data.results.forEach((job) => {
                if (job.id !== currentJob.id) {
                  const translatedLocation =
                    job.location?.translations?.find((translation) => translation.language === lang)
                      ?.title || t('job.nolocation');
                  jobs.push({
                    label: job.title,
                    value: job.id,
                    helpText: `${translatedLocation} • ${
                      job.deadline ? abbreviateDate(job.deadline, lang) : t('job.nodeadline')
                    }`,
                  });
                }
              });
            }
            callback(jobs);
          });
      }, 300),
    [company.id, currentJob.id, lang, t],
  );

  return (
    <SelectAsync
      label={label}
      placeholder={t('application.movecopy.selectjob')}
      defaultOptions
      loadOptions={searchJobs}
      defaultValue={job ? { value: job.id, label: job.title } : undefined}
      onChange={onSelect}
      loadingMessage={() => t('application.movecopy.selectjob.searching')}
      noOptions={({ inputValue }) => {
        if (inputValue !== '') return t('application.movecopy.selectjob.nomatch', inputValue);
        return t('application.movecopy.selectjob.nojobs');
      }}
    />
  );
});
